import type { NumberSchema } from 'yup';
import { object, number } from 'yup';

import type { JwtTokenUserSerialized } from '@playq/octopus2-auth';

export interface IJwtToken extends JwtTokenUserSerialized {
  exp: number;
  iat: number;
}

function dateValid(method: NumberSchema): NumberSchema {
  return method.test(
    'ISOString',
    // eslint-disable-next-line no-template-curly-in-string
    '${path} is not ISOString',
    (value) => value !== undefined && new Date(value) instanceof Date
  );
}

function expSchema(method: NumberSchema): NumberSchema {
  return dateValid(method).test(
    'Expiration',
    // eslint-disable-next-line no-template-curly-in-string
    '${path} is expired',
    (value) => value !== undefined && value > Date.now() / 1000
  );
}

export const baseTokenSchema = object({
  exp: expSchema(number()),
  iat: dateValid(number()),
});
